import { AssistantMessageCopyButton } from "#features/conversations/components/conversation-view/AssistantMessageCopyButton.tsx";
import { AssistantMessageRatingButton } from "#features/conversations/components/conversation-view/AssistantMessageRatingButton.tsx";
import type { ConversationMessage } from "#types/types.ts";
import { Flex } from "@hopper-ui/components";

interface Props {
    conversationId: string;
    message: ConversationMessage;
}

export const AssistantMessageToolbar = ({ conversationId, message }: Props) => {
    return (
        <Flex gap="inline-sm" marginLeft="auto">
            <AssistantMessageRatingButton
                conversationId={conversationId}
                message={message}
                rating="good"
            />
            <AssistantMessageRatingButton
                conversationId={conversationId}
                message={message}
                rating="bad"
            />
            <AssistantMessageCopyButton
                conversationId={conversationId}
                message={message}
            />
        </Flex>
    );
};
